export default "__VITE_ASSET__D9m4_83w__"